export class BaseModel<T> {
  id: string;
}
